<template>
  <YwPage/>
</template>

<script>
import YwPage from '@/YwPage.vue'
export default {
  name: 'App',
  components: {
    YwPage
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  padding: 5px;
}
</style>
